export default __webpack_public_path__ + "static/media/ufo.77ad0e80.png";